module.exports = __webpack_public_path__ + "img/microsoft.8a785075.svg";